import { TripTimelinePanel } from '../features/trip-timeline/components/TripTimelinePanel';

/** The trip's planned-vs-actual timeline, for the trip page. It loads and reports its own empty and failed states. */
export function TripTimelineSection({ tripId, tripNumber, refreshKey }: { tripId: string; tripNumber: string; refreshKey?: number }) {
  return <TripTimelinePanel tripId={tripId} tripNumber={tripNumber} refreshKey={refreshKey} />;
}
